import React, { FunctionComponent } from 'react';
import classNames from 'classnames';
import { DealerLaunchStepProps } from '../types';
import onlineImage from '../../../assets/online-product.png';
import instoreImage from '../../../assets/instore-product.png';
import completeImage from '../../../assets/complete-product.png';
import { Button } from '../../Input/Button/Button';
import { LinkButton } from '../../Input/Button/LinkButton';
import styles from '../styles.module.scss';

export const DealerLaunchProductSelect: FunctionComponent<DealerLaunchStepProps> = ({
  dealer,
  nextStep,
}) => {
  const renderSelectTagline = () => (
    <p className={styles.selectedProductTagline}>Your Selected Product</p>
  );
  const onBegin = () => {
    const features = !dealer.launchpad?.features
      ? { online: true, instore: true }
      : dealer.launchpad?.features;
    nextStep({
      launchpad: { status: { finishedProductSelect: true }, features },
    });
  };

  const onlyOnlineSelected =
    !!dealer.launchpad?.features?.online &&
    !dealer.launchpad?.features?.instore;
  const onlyInstoreSelected =
    !dealer.launchpad?.features?.online &&
    !!dealer.launchpad?.features?.instore;
  const completeSelected = !onlyOnlineSelected && !onlyInstoreSelected;
  return (
    <div className={classNames(styles.stepContainer, styles.productSelectStep)}>
      <div className={styles.stepTitle}>
        Please confirm your product selection
      </div>
      <div className={styles.stepSubtitle}>
        We&apos;ve highlighted your selection, but you can always have a look at
        what else we offer and upgrade to one of our other solutions any time.
      </div>
      <div className={styles.productContainer}>
        <div className={styles.stepCard}>
          <h1>Upstart Auto Retail Online</h1>
          {onlyOnlineSelected && renderSelectTagline()}
          <img src={onlineImage} alt="Online" />
          <p>
            Supercharge your dealership website with Upstart Auto Retail Online.
            Let customers buy directly from your website with our comprehensive
            solution that integrates seemlessly with your existing dealership
            website.
          </p>
          <div className="spacer" />
          {onlyOnlineSelected ? (
            <Button
              label="Begin Online Setup"
              variant="primary"
              onClick={onBegin}
            />
          ) : (
            <LinkButton
              label="Learn About Upstart Auto Retail Online"
              to="https://www.upstart.com/dealers/how-it-works/online-retail/"
              rawLink
              openNewWindow
            />
          )}
        </div>
        <div className={styles.stepCard}>
          <h1>Upstart Auto Retail In Store</h1>
          {onlyInstoreSelected && renderSelectTagline()}
          <img src={instoreImage} alt="In Store" />
          <p>
            Streamline your dealership sales process and provide a fabulous
            customer experience for every person that walks through your doors.
            Our in store solution will guide your salesforce to a more effective
            sales process.
          </p>
          <div className="spacer" />
          {onlyInstoreSelected ? (
            <Button
              label="Begin In Store Setup"
              variant="primary"
              onClick={onBegin}
            />
          ) : (
            <LinkButton
              label="Learn About Upstart Auto Retail In Store"
              to="https://www.upstart.com/dealers/how-it-works/in-store-digital-retail/"
              rawLink
              openNewWindow
            />
          )}
        </div>
        <div className={styles.stepCard}>
          <h1>Complete Solution</h1>
          {completeSelected ? (
            renderSelectTagline()
          ) : (
            <p className={styles.completeProductTagline}>
              Includes Online and In Store
            </p>
          )}
          <img src={completeImage} alt="Complete" />
          <p>
            Cover all your bases with Upstart Auto Retail&apos;s complete
            solution that includes both online and in store sales. Get setup
            today to launch both Upstart Auto Retail Online and Upstart Auto
            Retail In Store.
          </p>
          <div className="spacer" />
          {completeSelected ? (
            <Button
              label="Begin Complete Solution Setup"
              variant="primary"
              onClick={onBegin}
            />
          ) : (
            <LinkButton
              label="Learn About Our Complete Solution"
              to="https://www.upstart.com/dealers"
              rawLink
              openNewWindow
            />
          )}
        </div>
      </div>
    </div>
  );
};
